import { extensionOf, fileKindOf } from '../../core/file-facts';

/**
 * A material's type, drawn as the page it is: a sheet with a folded corner and its extension on
 * a band in the colour people already know it by — PowerPoint's orange, Word's blue, a PDF's
 * red.
 *
 * Ported from Project 180's `files/FileIcon.tsx`. What a card shows when there is no thumbnail
 * — a Word or text file, a PDF whose thumbnail is not drawn yet, or one that failed to load.
 *
 * Decorative: every place it appears also says the type in words, in the facts line.
 */
export default function FileIcon({
  contentType,
  size = 'md',
}: {
  contentType: string;
  size?: 'sm' | 'md' | 'lg';
}) {
  return (
    <span className={`file-icon is-${fileKindOf(contentType)} is-${size}`} aria-hidden="true">
      <span className="file-icon-sheet" />
      <span className="file-icon-band">{extensionOf(contentType).toUpperCase()}</span>
    </span>
  );
}
